import { render } from "./AdministratorLayout.vue?vue&type=template&id=70a1d819&scoped=true"
import script from "./AdministratorLayout.vue?vue&type=script&lang=js"
export * from "./AdministratorLayout.vue?vue&type=script&lang=js"

import "./AdministratorLayout.vue?vue&type=style&index=0&id=70a1d819&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1d819"]])

export default __exports__